import React from "react";
import {
  Layout,
  Avatar,
  Dropdown,
  Space,
  Typography,
  Button,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  DownOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import get from "lodash/get";

import * as ROUTES from "../../constants/routes";

const { Header } = Layout;
const { Text } = Typography;

const LayoutHeader = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => get(state, "auth.user"));

  const handleProfileClick = () => {
    navigate(ROUTES.userDetailsPath(get(user, "uuid")));
  };

  const handleLogout = () => {
    navigate(ROUTES.LOGOUT);
  };

  const menuItems = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "My Profile",
      onClick: handleProfileClick,
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <Header className="app-header">
      {/* 🔹 Left: Sidebar toggle */}
      <Button
        type="text"
        className="app-header__toggle"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={onToggle}
        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      />

      {/* 🔹 Right: User Menu */}
      {user && (
        <Dropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          trigger={["click"]}
        >
          <Button type="text" className="app-header__user">
            <Space size={10}>
              <Avatar
                size="default"
                icon={<UserOutlined />}
                className="app-header__avatar"
              />
              <div className="app-header__user-meta">
                <Text strong>
                  {user.first_name} {user.last_name}
                </Text>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Account
                </Text>
              </div>
              <DownOutlined style={{ fontSize: 12 }} />
            </Space>
          </Button>
        </Dropdown>
      )}
    </Header>
  );
};

export default LayoutHeader;
